import { render, staticRenderFns } from "./AlertsView.vue?vue&type=template&id=76173298&scoped=true"
import script from "./AlertsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AlertsView.vue?vue&type=style&index=0&id=76173298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76173298",
  null
  
)

export default component.exports